import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const ConfirmationDialog = ({
  open,
  handleClose,
  title,
  message,
  onConfirm,
  loading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ mb: 2, mr: 2 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          color="primary"
          sx={{ mr: 1 }}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          onClick={onConfirm}
          color="error"
          autoFocus
          disabled={loading}
        >
          {loading && (
            <CircularProgress size={24} sx={{ mr: 1 }} color="error" />
          )}
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
